import { motion } from 'motion/react';
import { Shield, Users, Gavel, LayoutGrid, Zap, Bell, Lock, Sparkles } from 'lucide-react';
import { MarketingLayout } from '../../layouts/MarketingLayout';

const features = [
  { icon: Shield, title: 'Biometric Security', desc: 'WebAuthn passkeys protect your identity with the device you already trust.' },
  { icon: Users, title: 'Social Circles', desc: 'Specialized circles for collaboration, mentorship, and growth.' },
  { icon: Gavel, title: 'Decentralized Governance', desc: 'Transparent voting and proposals — every voice is recorded on-chain.' },
  { icon: LayoutGrid, title: 'Unified App Ecosystem', desc: 'One identity, one data layer, dozens of apps that just work together.' },
  { icon: Zap, title: 'Lightning Fast', desc: 'Sub-second latency across our distributed mesh, anywhere in the world.' },
  { icon: Bell, title: 'Smart Notifications', desc: 'Cross-app, intent-aware notifications that respect your focus.' },
  { icon: Lock, title: 'Field-Level Privacy', desc: 'Choose exactly what each app can read, and revoke access in one tap.' },
  { icon: Sparkles, title: 'Built-In AI Copilots', desc: 'Assistants embedded in every module — drafting, summarizing, suggesting.' },
];

export const Features = () => {
  return (
    <MarketingLayout
      title="Everything you need in one place"
      subtitle="We've built a foundation that handles the complex stuff, so you can focus on connecting and creating."
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {features.map((f, i) => (
          <motion.div
            key={f.title}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.05 }}
            className="flex gap-5 p-6 rounded-2xl border border-slate-100 bg-slate-50/50"
          >
            <div className="flex-shrink-0 h-12 w-12 rounded-xl bg-indigo-600 text-white flex items-center justify-center">
              <f.icon size={22} />
            </div>
            <div className="space-y-1">
              <h3 className="font-bold text-slate-900">{f.title}</h3>
              <p className="text-sm text-slate-600 leading-relaxed">{f.desc}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </MarketingLayout>
  );
};
